const NewQuote = () => {
    const main = document.getElementById('new-quote');

    if (!main) return;

    const element =  {
        inputQuoteFile: $('#customFile'),
        labelQuoteFile: $('#label-quote-file')
    };

    element.inputQuoteFile.on('change', function (e) {
        element.labelQuoteFile.text(e.target.files[0].name);
    });
};

$(() => {
    NewQuote();
});
